import {
  BannerAdsNavigateTo,
  BannerAdsNavigateToRoutePath,
  BannerAdsPosition,
  RoutePath,
} from "@app/constants";
import { selectBannerAds } from "@app/store/banner-ads";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";

function BannerAdsComponent({
  position,
  className = "",
}: {
  position: BannerAdsPosition;
  className?: string;
}) {
  const bannerAdsState = useSelector(selectBannerAds);

  const navigate = useNavigate();

  const bannerAds = bannerAdsState.list.find(
    (item) => item.position === position
  );

  const render = () => {
    const clean = bannerAds?.script ? DOMPurify.sanitize(bannerAds.script) : "";

    return clean;
  };

  const handleBannerClick = () => {
    if (!bannerAds) return;

    if (bannerAds.bookId) {
      return navigate(`/${RoutePath.BOOK_DETAIL}/${bannerAds.bookId}`);
    }

    if (bannerAds.categoryId) {
      return navigate(
        `${RoutePath.BOOK_BY_CATEGORY}?category_id=${bannerAds.categoryId}`
      );
    }

    if (
      bannerAds.navigateTo &&
      Object.values(BannerAdsNavigateTo).includes(bannerAds.navigateTo)
    ) {
      return navigate(BannerAdsNavigateToRoutePath[bannerAds.navigateTo]);
    }
  };

  return (
    <>
      {!!bannerAds && (
        <div
          className={`cursor-pointer h-[360px] w-full rounded-3xl mx-auto [&_a]:pointer-events-none [&_a_img]:mx-auto [&_a_img]:rounded-3xl ${className}`}
          dangerouslySetInnerHTML={{ __html: render() }}
          onClick={handleBannerClick}
        ></div>
      )}
    </>
  );
}

export default BannerAdsComponent;
